import {NodeType, ResolvedPos} from "prosemirror-model";


export const getParentWithNodeTypePos = (
    $from: ResolvedPos,
    nodeType: NodeType
): number | undefined => {
    for (let depth = $from.depth; depth >= 0; depth--) {
        const parent = $from.node(depth)

        if (parent.type === nodeType) {
            return $from.before(depth)
        }
    }
    return undefined;
}
